import { create } from 'zustand';

const useActiveBrandsStore = create((set) => ({
  activeBrands: [],
  setActiveBrands: (newActiveBrands) => set((state) => ({ ...state, activeBrands: newActiveBrands })),
}));

export default useActiveBrandsStore;

